import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const ExtractedEventSchema = z.object({
  extractedEventId: PrimaryKeySchema,
  title: z.string(),
  description: z.string().nullable(),
  sourceIds: z.array(PrimaryKeySchema),
  relatedExtractedEventIds: z.array(PrimaryKeySchema),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ExtractedEvent = z.infer<typeof ExtractedEventSchema>;

export const ExtractedEventsSchema = z.array(ExtractedEventSchema);

export type ExtractedEvents = z.infer<typeof ExtractedEventsSchema>;

export const ExtractedEventWithDatesSchema = ExtractedEventSchema.extend({
  dates: z.array(
    z.object({
      extractedEventDateId: PrimaryKeySchema,
      parsedDate: z.coerce.date(),
    }),
  ),
});

export type ExtractedEventWithDates = z.infer<
  typeof ExtractedEventWithDatesSchema
>;

export const ExtractedEventsWithDatesSchema = z.array(
  ExtractedEventWithDatesSchema,
);

export type ExtractedEventsWithDates = z.infer<
  typeof ExtractedEventsWithDatesSchema
>;

export const ExtractedEventsQuerySchema = z
  .object({
    extractedEventIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    timelineRequestIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    sourceIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
  })
  .merge(
    createOffsetPaginationRequestQuerySchema(z.enum(['createdAt', 'minDate'])),
  );

export type ExtractedEventsQuery = z.infer<typeof ExtractedEventsQuerySchema>;

export const CreateExtractedEventSchema = z.object({
  title: z.string(),
  description: z.string().nullable(),
});

export type CreateExtractedEvent = z.infer<typeof CreateExtractedEventSchema>;
